// @flow

import React, { Component } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import type { Props } from '.';
import LoadingModal from '../modals/loading';
import './dao.scss';

class Dao extends Component<Props> {
  imageNumber: number = Math.floor(Math.random() * 6 + 1);

  props: Props;

  componentDidMount() {
    const { getDao } = this.props;
    moment.locale(navigator.language);
    getDao();
  }

  componentDidUpdate(prevProps: Props) {
    // Typical usage (don't forget to compare props):
    const { user, getDao } = this.props;
    if (user && prevProps.user && user.cae !== prevProps.user.cae) {
      getDao();
    }
  }

  renderLoadingBar = (
    <LoadingModal />
  );

  shouldRenderDistributionAmount() {
    const { dao } = this.props;
    return dao.dao.systemAvailable && dao.dao.distributionAmount > 0;
  }

  shouldRenderDistributionDate() {
    const { dao } = this.props;
    const { distributionDate, systemAvailable } = dao.dao;
    const now = moment();
    return systemAvailable && !now.isSame(distributionDate, 'day');
  }

  systemUnavailable() {
    const { dao } = this.props;
    return dao.dao.systemAvailable === false;
  }

  renderDistributionAmount(amount) {
    const fractionAmount = amount.toLocaleString(
      navigator.language,
      { minimumFractionDigits: 2 },
    );
    const fractionAmounts = fractionAmount.split('.');
    return (
      <span className="dao--payment lime">
        {String.fromCharCode(163)}
        {fractionAmounts[0]}
        {'.'}
        <span className="dao--payment-decimal">{fractionAmounts[1]}</span>
      </span>
    );
  }

  renderMessage() {
    const { dao } = this.props;
    const {
      distributionAmount,
      distributionDate,
      systemAvailable,
      distributionMessage,
    } = dao.dao;

    if (!systemAvailable) {
      return distributionMessage;
    }
    const prsTodayDist = 'Your next PRS royalty payment is arriving today.';
    const prsTodayNoDist = 'You have not received a royalty payment in this PRS distribution';
    const prsNextDist = 'Your latest performing royalty distribution is arriving on';
    const prsNextNoDist = 'You will not receive a payment in the performing royalty distribution on';
    const prsLastDist = 'The last performing royalty distribution was on';
    const prsLastNoDist = 'You did not receive a payment in the last PRS distribution on';

    const now = moment();

    if (now.isSame(distributionDate, 'day') && distributionAmount > 0) {
      return prsTodayDist;
    }
    if (now.isSame(distributionDate, 'day') && distributionAmount === 0) {
      return prsTodayNoDist;
    }
    if (now.isAfter(distributionDate, 'day') && distributionAmount > 0) {
      return prsLastDist;
    }
    if (now.isAfter(distributionDate, 'day') && distributionAmount === 0) {
      return prsLastNoDist;
    }
    if (now.isBefore(distributionDate, 'day') && distributionAmount > 0) {
      return prsNextDist;
    }
    // if (now.isBefore(distributionDate, 'day') && distributionAmount === 0) {
    return prsNextNoDist;
  }

  renderContent = () => {
    const { dao } = this.props;
    return (
      <React.Fragment>
        <div className="dao">
          <h2>My distribution</h2>
          {this.shouldRenderDistributionAmount() && (
            <p>
              {this.renderDistributionAmount(dao.dao.distributionAmount)}
              <button
                type="button"
                className="prs-icon clickable prs-chevron-collapse collapsed dao-more-info-icon"
                data-toggle="collapse"
                data-target="#dao__more_info"
                aria-expanded="false"
                aria-controls="dao__more_info"
              />
            </p>
          )}
          <div
            className={classnames(
              'dao__more_info',
              'overflow-hidden',
              { collapse: this.shouldRenderDistributionAmount() },
            )}
            id="dao__more_info"
          >
            <p className={classnames([
              'dao__message d-flex flex-row align-items-center',
              { 'dao__message--system-not-available': !dao.dao.systemAvailable },
            ])}
            >
              {this.systemUnavailable() && <span className="prs-icon prs-icon-alert" />}
              {this.renderMessage()}
            </p>
            {this.shouldRenderDistributionDate() && (
              <p>
                <time className="dao__more_info_date">
                  <span>
                    {moment(dao.dao.distributionDate).format(
                      'DD MMMM YYYY',
                    )}
                  </span>
                </time>
              </p>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const {
      dao,
    } = this.props;
    return dao && dao.dao ?
      this.renderContent() :
      this.renderLoadingBar;
  }
}

export default Dao;
